import { unauthedRequest } from './requests'

/**
 *
 * /password resource requests
 *
 */
export const postPasswordReset =
  ({ email }) =>
    unauthedRequest('v2/password', {
      method: 'POST',
      body: JSON.stringify({
        user: {
          email,
        }
      })
    });

export const patchPasswordReset =
  ({ password, password_confirmation, reset_password_token }) =>
    unauthedRequest('v2/password', {
      method: 'PATCH',
      body: JSON.stringify({
        user: {
          password,
          password_confirmation,
          reset_password_token,
        }
      })
    });




// WEBPACK FOOTER //
// ./src/utils/api/password.js